<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="stock"
      :search="search"
      disable-initial-sort
      hide-default-footer
  
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr
          :style="{backgroundColor: (props.item.price == '0' ? '#ffffff' : props.item.price == '' ? '#ffffff': '#1976d21A' ) }"
        >
          <td class="text-xs-right">
            <b>PO{{ props.item.po_id }}</b>
          </td>
          <td>
            <v-avatar size="38">
              <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
            </v-avatar>
          </td>
          <td class="text-xs-right">{{ props.item.product_name }}</td>
          <td class="text-xs-right">{{ props.item.grade }}</td>
          <td class="text-xs-right">{{ props.item.location }}</td>
          <td class="text-xs-right">{{ props.item.weight_type }}</td>
          <td class="text-xs-right">{{ props.item.quantity }}</td>
          <td
            class="text-xs-right"
            :style="{color: (props.item.total_weight.includes('deducted') ? 'green'  : '#000000' ) }"
          >{{ props.item.total_weight }}</td>

          <td class="text-xs-right">
            <v-btn
              @click="getBalanceRecord(props.item.balance_detail,props.item.product_id,props.item.vege_stocked_date)"
              :color="(props.item.balance_detail.includes('over') ? 'warning'  : 'primary' )"
            >{{props.item.balance_detail}}</v-btn>
          </td>

          <td class="text-xs-right">
            <v-text-field
              v-model="props.item.price"
              label="price"
              v-on:change="DebounceUpdatePrice(props.item.id,props.item.price)"
              type="number"
              :placeholder="props.item.price"
              @focus="$event.target.select()"
            ></v-text-field>
          </td>

          <td class="text-xs-right">{{ parseFloat(props.item.weight_after_deduction * props.item.price).toFixed(2) }}</td>
          <td class="justify-end layout px-5">
            <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
            <v-icon medium color="error" @click="deleteItem(props.item)">delete_forever</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="d-flex">
      <v-layout >
        <v-flex md7>
        <v-pagination v-model="stock_offset" :length="stock_total_page" total-visible="5"></v-pagination>
        </v-flex>
        <v-flex md5>
      

        TOTAL STOCK: {{total_stock}}
    
        </v-flex>
          </v-layout>
       
      </div>
    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="2500">
      {{response}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog_edit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit item</span>
        </v-card-title>

        <v-card-text>
          <edit_dialog ref="edit" @update="getInvoiceItem(invoice_id,farmer_id)"></edit_dialog>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_balance_record">
      <v-card>
        <v-card-title>
          <span class="headline">Record</span>
        </v-card-title>

        <v-card-text>
          <balance_record ref="balance_record"></balance_record>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import edit_dialog from "@/components/large_component/po_edit_dialog";
import balance_record from "@/components/large_component/balance_price_detail";

import { debounce } from "lodash";

export default {
  components: {
    edit_dialog,
    balance_record
  },
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    errors: "",
    baseUrl: baseUrl,

    stock_offset:1,
    stock_limit:5,
    total_stock:'',
    stock_total_page:1,

    headers: [
      { text: "PO", align: "left", value: "po_id" },
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "left", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Locate", align: "right", value: "location" },
      { text: "KG", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "Total Kg/box", align: "right", value: "total_weight" },
      { text: "Balance PRICE", align: "right", value: "balance_detail" },
      { text: "Price per kg", align: "left", value: "price" },

      { text: "Amount", align: "right", value: "" },
      { text: "tools", align: "right", value: "id", sortable: false }
    ],
    stock: [],
    selected_farmer: "",
    selected_po_id: "",
    snackbar_response: false,
    response: "",
    type_need_weight: false,
    dialog_edit: false,
    invoice_id: "",
    dialog_balance_record: false,
    farmer_id:""
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {},

  methods: {
    getInvoiceItem: function(invoice_id,farmer_id) {

      this.stock=[];  
      this.dialog_edit = false;
      this.invoice_id = invoice_id;
      this.farmer_id = farmer_id;
      const params = new URLSearchParams();
      console.log('ggg')

      params.append("getInvoiceItem", "getInvoiceItem");
      params.append("invoice_id", this.invoice_id);
      params.append("stock_limit", this.stock_limit);
      params.append("stock_offset", this.stock_offset);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.stock = response.data.data;
            this.total_stock = response.data.total_stock;
            this.stock_total_page = response.data.stock_total_page;

          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
       
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    deleteItem(item) {
      const params = new URLSearchParams();
      params.append("deletePOStock", "deletePOStock");
      params.append("id", item.id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.getInvoiceItem(this.invoice_id);
            this.snackbar_response = true;
            this.response = response.data.message;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.snackbar_response = true;
            this.response = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    DebounceUpdatePrice: _.debounce(function(id, price) {
      this.updatePrice(id, price);
    }, 300),
    updatePrice(id, price) {
      const params = new URLSearchParams();
      params.append("updatePrice", "updatePrice");
      params.append("id", id);
      params.append("price", price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            // this.fetch_do_item();
            console.log(response.data.message);

            this.snackbar_response = true;
            this.response = response.data.message;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    editItem(id) {
      this.dialog_edit = true;
      this.$refs.edit.fetch_item(id,this.farmer_id);
    },
    getBalanceRecord(balance_detail, product_id, vege_stocked_date) {
      console.log(product_id);
      console.log(vege_stocked_date);
      this.dialog_balance_record = true;
      this.$refs.balance_record.getrecord(
        balance_detail,
        vege_stocked_date,
        product_id
      );
    }
  }
};
</script>

